<mat-stepper [linear]="true" class="stepper" *ngIf="allAssetsLoaded()">
    <mat-step [stepControl]="whenFormGroup">
        <p style="font-size: 16px; color: #d90000;" *ngIf="isUnlocked">The menu is not locked, products may be
            automatically changed.</p>
        <form [formGroup]="whenFormGroup" class="form">
            <ng-template matStepLabel>Type</ng-template>
            <mat-form-field style="width: 100%">
                <mat-label>Type of delivery</mat-label>
                <mat-select formControlName="typeDelivery" (selectionChange)="onTypeDeliveryChange($event)">
                    @for (extraDeliveryType of extraDeliveryTypes; track extraDeliveryType; let i = $index) {
                    <mat-option [value]="extraDeliveryType">{{extraDeliveryType}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Choose a date (latest 14:00)</mat-label>
                <input formControlName="date" matInput [matDatepicker]="picker"
                    (dateInput)="onDateSelect('input', $event)" (dateChange)="onDateSelect('change', $event)"
                    [matDatepickerFilter]="dateFilter">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div>
                <button mat-button (click)="close()">Close</button>
                <button mat-raised-button color="primary" matStepperNext (click)="onNextOnTypeForm()">Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="costumerFormGroup">
        <ng-template matStepLabel>Costumer</ng-template>
        <form [formGroup]="costumerFormGroup" class="form">
            <mat-form-field style="width: 100%"
                *ngIf="this.whenFormGroup.get('typeDelivery').value == extraDeliveryTypes[0]">
                <mat-label>Costumer</mat-label>
                <input type="text" placeholder="Pick one" aria-label="Number" matInput formControlName="system"
                    [matAutocomplete]="auto" formControlName="system">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (system of filteredSystems | async; track system) {
                    <mat-option [value]="system">{{system.name}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Desciption (max 30)</mat-label>
                <input matInput placeholder="Exam, Party etc." formControlName="desciption" maxlength="30">
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Comment</mat-label>
                <textarea matInput placeholder="Place, appartment etc." formControlName="comment"></textarea>
            </mat-form-field>

            <div>
                <button mat-button (click)="close()">Close</button>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext>Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="whatFormGroup">
        <ng-template matStepLabel>Products</ng-template>
        <p>Products</p>
        <p style="font-size: 16px; color: #d90000;" *ngIf="isUnlocked">The menu is not locked, products may be
            automatically changed.</p>
        <p style="font-size: 16px; color: #d90000;" *ngIf="!relevantMenu">The products for this week is not planed.</p>
        <div>
            <form [formGroup]="whatFormGroup" class="form">
                <div style="display: flex; flex-direction: column; gap: 10px;">
                    <mat-form-field style="width: 100%">
                        <mat-label>Presets</mat-label>
                        <mat-select formControlName="presets" (selectionChange)="onSelectPreset($event)">
                            @for (preset of getPresets(); track preset; let i = $index) {
                            <mat-option [value]="preset">{{preset.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field style="width: 100%">
                        <mat-label>Products</mat-label>
                        <mat-select formControlName="product">
                            <!-- @for (category of getCategorys(); track category) {
                            <mat-optgroup [label]="category | titlecase"> -->
                                @for (product of getMenuProducts(category); track product) {
                                <mat-option [value]="product">{{product.name}}</mat-option>
                                }
                            <!-- </mat-optgroup>
                            } -->
                        </mat-select>
                    </mat-form-field>
                    <button mat-raised-button color="primary" (click)="addProduct()">Add</button>
                </div>
            </form>

            <mat-table [dataSource]="dataSource$" style="padding-bottom: 30px;">

                <ng-container matColumnDef="qty">
                    <mat-header-cell *matHeaderCellDef> Qty. </mat-header-cell>
                    <mat-cell *matCellDef="let product"><input type="number" [(ngModel)]="product.amount" value="1"
                            min="0" [max]="product.max"></mat-cell>
                </ng-container>

                <ng-container matColumnDef="max">
                    <mat-header-cell *matHeaderCellDef> Max </mat-header-cell>
                    <mat-cell *matCellDef="let product"> {{product.max}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="product">
                    <mat-header-cell *matHeaderCellDef> Product </mat-header-cell>
                    <mat-cell *matCellDef="let product"> {{product.product.name}} <ng-container
                            *ngIf="product.newProduct && product.newProduct.id != product.product.id">->
                            {{product.newProduct.name}}</ng-container></mat-cell>
                </ng-container>
                <ng-container matColumnDef="remove">
                    <mat-header-cell *matHeaderCellDef> Remove </mat-header-cell>
                    <mat-cell *matCellDef="let product">
                        <button mat-icon-button (click)="removeProduct(product)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="['qty', 'max', 'product', 'remove']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['qty', 'max', 'product', 'remove']"></mat-row>
            </mat-table>

            <button mat-button (click)="close()">Close</button>
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext>Next</button>
        </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Summary</ng-template>
        <div class="summary">
            <p>Type: {{whenFormGroup.get('typeDelivery').value}}</p>
            <p>Date: {{whenFormGroup.get('date').value | date:'dd.MM.yyyy'}}</p>
            <p>Costumer: {{costumerFormGroup.get('system').value ? costumerFormGroup.get('system').value.name : ''}}</p>
            <p>Desciption: {{costumerFormGroup.get('desciption').value}}</p>
            <p>Comment: {{costumerFormGroup.get('comment').value}}</p>
            <p>Notification email: {{ createrMail }}</p>
            <p>Products:</p>
            <ul>
                @for (product of selectedProducts; track product) {
                <li>{{product.amount}} x {{product.product.name}} <ng-container
                        *ngIf="product.newProduct && product.newProduct.id != product.product.id">->
                        {{product.newProduct.name}}</ng-container> </li>
                }
            </ul>

        </div>
        <button mat-button (click)="close()">Close</button>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-raised-button color="primary" *ngIf="orderInDateRange()" (click)="placeOrder(false)">{{data.delivery
            ? 'Update' : 'Order'}}</button>
        <button mat-raised-button color="primary" *ngIf="data.delivery" (click)="placeOrder(true)">Copy</button>
        <button mat-raised-button color="warn" *ngIf="data.delivery" (click)="cancelOrder()">Cancle order</button>
    </mat-step>
</mat-stepper>